module.exports = __webpack_public_path__ + "static/media/sheild-dynamic-gradient.8769567e.png";